import angular from 'angular';
import './activeEngage.scss';
import service from './activeEngage.service';

export default angular.module('vdp.shared.activeEngage', [
    /* your module dependencies go here */
])

.service('activeEngage', service)

.name;
